import React from "react";
import { useTranslation } from "react-i18next";
import { TYPE } from "../../../../constant";

function TutorialTooltip({ isShow, setStep, curStep, onClick }) {
  const handleClickBtn = (e) => {
    e.preventDefault();
    onClick();
  };

  if (!isShow) return null;

  return (
    isShow &&
    setStep === curStep && <StepPopup step={curStep} onClick={handleClickBtn} />
  );
}

function StepPopup({ step, onClick }) {
  const { t, i18n } = useTranslation();

  return (
    <div className={`tutorial-tip ${step} active`}>
      <div className="tip-inner">
        <p className="tip-txt">
          {step === TYPE.TUTORIAL.STEP1 && (
            <span dangerouslySetInnerHTML={{ __html: t("TUTORIAL.msg001") }} />
          )}
          {step === TYPE.TUTORIAL.STEP2 && (
            <span dangerouslySetInnerHTML={{ __html: t("TUTORIAL.msg002") }} />
          )}
          {step === TYPE.TUTORIAL.STEP3 && (
            <span dangerouslySetInnerHTML={{ __html: t("TUTORIAL.msg003") }} />
          )}
        </p>
        {i18n.language === "ko" && (
          <button
            className={`btn-step ${step === TYPE.TUTORIAL.STEP3 ? "fin" : ""}`}
            onClick={onClick}
          >
            {i18n.language === "ko" && step === TYPE.TUTORIAL.STEP3
              ? "확인"
              : "다음"}
          </button>
        )}
        {i18n.language === "en" && (
          <button
            className={`btn-step ${step === TYPE.TUTORIAL.STEP3 ? "fin" : ""}`}
            onClick={onClick}
          >
            {i18n.language === "en" && step === TYPE.TUTORIAL.STEP3
              ? "Finish"
              : "Next"}
          </button>
        )}
      </div>
    </div>
  );
}

TutorialTooltip.defaultProps = {
  step: TYPE.PAYMENT.STEP_1,
  onClick: () => {},
};

export default TutorialTooltip;
